module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/rectangle-bdfb232c33bd439c064768faa6af35af.png";